__webpack_require__.p = "https://bundle.stayforlong.com/20251212.1/_next/";